<div class="app-tag tag" *ngIf="tagType === 'app' ">
  <span class="fa fa-android"></span>
  {{tagTxt}}
</div>

<button type="button" class="value-tag tag" *ngIf="tagType === 'value' ">{{tagTxt}}</button>

<button type="button" class="rect-tag" *ngIf="tagType === 'rectangle'"
  [ngStyle]="{'padding-right' : noRemoveTag ? '13px' : '30px'}">
  <div class="rect-tag-txt">{{tagTxt}}</div>
  <div class="rect-tag-remove" (click)="tagRemoveCicked($event); $event.stopPropagation();" *ngIf="!noRemoveTag">
    <i class="material-icons">
      close
    </i>
  </div>
</button>


<button type="button" class="rect-rounded-tag tag" *ngIf="tagType === 'rounded' "
  [ngStyle]="{'padding-left' : ref.innerHTML.trim() ? '35px' : '13px', 'padding-right' : noRemoveTag ? '13px' : '30px'}">
  <div #ref>
    <ng-content></ng-content>
  </div>
  <div class="rect-rounded-tag-txt">{{tagTxt}}</div>
  <div class="rect-rounded-tag-remove" (click)="tagRemoveCicked($event, tagTxt); $event.stopPropagation();"
    *ngIf="!(noRemoveTag)">
    <i class="material-icons">
      close
    </i>
  </div>
</button>


<div class="image-tag tag round-btn" [ngClass]="{'header-icon': this.headerIcon}" *ngIf="tagType === 'imgTxt' ">
  <div class="text" *ngIf="getImgTxtTag(tagTxt) === 'img'; else txtInitial">
    <img src="{{tagTxt}}">
  </div>

  <ng-template #txtInitial>
    <div class="text">{{getImgTxtTag(tagTxt)}}</div>
  </ng-template>
</div>
